import cn from 'classnames';

import * as styles from './styles.module.css';

const inRange = (
  time: number,
  fromTime?: number,
  toTime?: number,
  hoveredDate?: Date
) => {
  if (!fromTime && !toTime) return false;

  if (fromTime && toTime) {
    return fromTime < time && toTime > time;
  } else {
    const selectedDate = (fromTime || toTime) as number;
    return (
      hoveredDate &&
      ((selectedDate < time && hoveredDate.getTime() > time) ||
        (time < selectedDate && time > hoveredDate.getTime()))
    );
  }
};

export const DayOfMonth = ({
  selectable,
  hoveredDate,
  outsideDay,
  dayIndex,
  date,
  selectedRange,
  ...props
}: any) => {
  const time = date.getTime();
  const fromTime = selectedRange.from?.getTime();
  const toTime = selectedRange.to?.getTime();
  const isHovered = hoveredDate && time == hoveredDate.getTime();

  const isFirst =
    fromTime && toTime
      ? fromTime == time
      : (fromTime == time && hoveredDate && hoveredDate.getTime() >= time) ||
        (isHovered && time < fromTime);
  const isLast =
    fromTime && toTime
      ? toTime == time
      : (fromTime == time && hoveredDate && hoveredDate.getTime() <= time) ||
        (isHovered && time > fromTime);
  const isInRange = inRange(time, fromTime, toTime, hoveredDate);
  const isInFullRange = isInRange || isFirst || isLast;

  return (
    <button
      {...props}
      className={cn('relative h-8 text-center font-normal', {
        'bg-feedback-error-surface': !selectable,
        [`${styles['day']} bg-surface-selected`]: isInRange,
        'text-content-brand': isInFullRange,
        'text-content-muted': outsideDay && !isInFullRange,
        'text-feedback-attention': dayIndex > 4 && !isInFullRange,
        'rounded-l-full bg-action-primary !text-white': isFirst,
        'rounded-r-full bg-action-primary !text-white': isLast
      })}
    >
      {selectable ? date.getDate() : 'X'}
    </button>
  );
};
